// src/config/tradingConfig.js

// Top 15 performing symbols from backtest
// These are the symbols actively traded by Variant B Tuned strategy
export const ACTIVE_TRADING_SYMBOLS = ['AAPL', 'ABBV', 'AMGN', 'AMD', 'AMZN', 'BA', 'BAC', 'C', 'CAT', 'DE', 'DIS', 'FDX', 'GE', 'GILD', 'GOOG', 'GOOGL', 'GS', 'INTC', 'JNJ', 'LMT', 'LYFT', 'MMM', 'MPC', 'MS', 'NFLX', 'NVDA', 'ORCL', 'PARA', 'PFE', 'QQQ', 'RTX', 'SLB', 'SPY', 'T', 'TSLA', 'UBER', 'XEL', 'XOM'];

export const STRATEGY_PARAMS = {
  name: 'Variant B Tuned',
  rsi_oversold: 40,
  max_hold_days: 12,
  target_multiplier: 2.5,
  emergency_stop_pct: -8.0,
  profit_protection_trigger: 12.0,
  profit_protection_floor: 6.0,
  position_size_pct: 0.065
};
